// extracted by mini-css-extract-plugin
export default {"bottomHeader":"Header_bottomHeader__j3ela"};